import { render, staticRenderFns } from "./areaselect.vue?vue&type=template&id=91775408&scoped=true"
import script from "./areaselect.vue?vue&type=script&lang=js"
export * from "./areaselect.vue?vue&type=script&lang=js"
import style0 from "./areaselect.vue?vue&type=style&index=0&id=91775408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91775408",
  null
  
)

export default component.exports